import React, { FC } from 'react'
import PolaroidText from '../PolaroidText'
import { pluralizeWord } from 'lib/helpers'
import styles from '../../Polaroid.module.scss'

type PolaroidPrintsQuantityProps = {
  onClick?: () => void
  printDimensions?: ReadonlyArray<string>
  printMaterials?: ReadonlyArray<string>
  printFrames?: Record<string, number>
}

const PolaroidPrintsQuantity: FC<PolaroidPrintsQuantityProps> = ({
  onClick,
  printDimensions = [],
  printMaterials = [],
  printFrames = {},
}) => {
  const sizesQuantity = printDimensions.length
  const materialsQuantity = printMaterials.length
  // const framesQuantity = Object.keys(printFrames).length

  // if (sizesQuantity === 0 && materialsQuantity === 0 && framesQuantity === 0) {
  if (sizesQuantity === 0 && materialsQuantity === 0) {
    return null
  }

  const printsQuantityText = [
    sizesQuantity > 0 ? `${sizesQuantity} ${pluralizeWord(sizesQuantity, 'size')}` : '',
    materialsQuantity > 0
      ? `${materialsQuantity} ${pluralizeWord(materialsQuantity, 'material')}`
      : '',
    // framesQuantity > 0 ? `${framesQuantity} ${pluralizeWord(framesQuantity, 'frame')}` : '',
  ]
    .filter(Boolean)
    .join(', ')

  return (
    <>
      <PolaroidText
        dataTestId='artwork-prints-quantity'
        onClick={onClick}
        customStyles={styles.customPrintsQuantityContainer}
      >
        Available in {printsQuantityText}
      </PolaroidText>
    </>
  )
}

export default PolaroidPrintsQuantity
